;(function(window, document) {
  let win = window
  let doc = document
  let draw = 414 // 出图大小,也是1：1的标准尺寸
  function setFontSize() {
    let winWidth = win.innerWidth
    // draw这个数字是根据你的设计图的实际大小来的，所以值具体根据设计图的大小
    let size = ((winWidth / draw) * 100) / 3
    // 最大只支持到640物理屏自适配
    // doc.documentElement.style.fontSize = (size < 200 ? size : 200) + 'px';
    doc.documentElement.style.fontSize = size + 'px'
  }
  setFontSize()
})(window, document)
